module.exports = __webpack_public_path__ + "static/media/GDocsPortalSiteTnC_ID.ac8f6ba5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff_PDF/GDocsPortalSiteTnC_ID.pdf
// module id = 692
// module chunks = 4